import { FC } from 'react'
import styles from './ProgressLine.module.scss'

const ProgressLine: FC<{
  progress?: number
  heightPx?: number,
}> = ({ progress, heightPx = 1 }) => (
  <div
    className={styles.progress}
    data-height={heightPx}
    {...(progress !== undefined ? { 'data-progress': progress } : {})}
  >
    <div className={styles.indeterminate}></div>
  </div>
)

export default ProgressLine
